// src/pages/Moderation/ModerationQueuePage/ModerationQueuePage.tsx
import React, { useMemo, useState } from 'react';
import './ModerationQueuePage.scss';

import { onDescription, onTitle } from 'CONST/text';
import { transformFlagCounts } from 'untils/transformFlagCounts';

import { QueueFilters } from 'components/Moderation/QueueFilters/QueueFilters';
import { QueueHeader } from 'components/Moderation/QueueHeader/QueueHeader';
import { QueueQuickStats } from 'components/Moderation/QueueQuickStats/QueueQuickStats';
import { QueueTabs } from 'components/Moderation/QueueTabs/QueueTabs';
import { ReportsTable } from 'components/Moderation/ReportsTable/ReportsTable';
import { Modal } from 'ui/NewModal/Modal';
import { useModerationQueue } from './model/useModerationQueue';

export const ModerationQueuePage: React.FC = () => {
  const { tab, counters, reports, flags, loader, pagination, setPagination, filters, setFilters } =
    useModerationQueue();

  const [confirmId, setConfirmId] = useState<string>('');

  const stats = useMemo(() => {
    const fc = counters?.data?.flag_counts;
    if (!fc) return { total: 0, data: { keys: [], values: [] } };

    const t = transformFlagCounts(fc);
    const total = t.values.reduce((acc, v) => acc + v, 0);

    return { total, data: t };
  }, [counters]);

  const sendDelete = async () => {
    const res = await fetch('/api/delete', { method: 'DELETE' });
    if (!res.ok) throw new Error('Delete failed');
  };

  return (
    <div className="moderation-queue-page">
      <QueueHeader title="Moderation Queue" />

      <div className="moderation-queue-page__content">
        <QueueFilters flags={flags} value={filters} onChange={setFilters} />

        <QueueTabs activeTab={tab} />

        <QueueQuickStats
          total={stats.total}
          data={stats.data}
          flags={flags}
          // якщо хочеш, щоб клік по “pill” фільтрував список:
          onPickFlag={(flagValue) => setFilters((f) => ({ ...f, flag: flagValue }))}
        />

        <ReportsTable
          data={reports}
          flags={flags}
          loading={loader}
          page={pagination.page}
          perPage={pagination.perPage}
          onPageChange={(page) => setPagination((p) => ({ ...p, page }))}
          onPerPageChange={(perPage) => setPagination((p) => ({ ...p, perPage }))}
          onAskConfirm={(id) => setConfirmId(id)}
        />
      </div>

      <Modal
        open={!!confirmId}
        title={onTitle(confirmId)}
        description={onDescription(confirmId)}
        confirmText="Confirm"
        cancelText="Cancel"
        onClose={() => setConfirmId('')}
        onConfirm={sendDelete}
      />
    </div>
  );
};

export default ModerationQueuePage;
